import { EqipFarmNumbersTaskEditor } from './EqipFarmNumbersTaskEditor'

export const EqipFarmNumbersFeatureMap = {
  Component: {
    traitId: 'eqipFarmNumbers' as const,
    TaskEditor: EqipFarmNumbersTaskEditor,
  },
  resourceType: 'workflow' as const,
}
